import styled, { css } from 'styled-components';
import { TextStatus } from '@cko/primitives';

export const levelOnePaddingStyle = css`
  padding: var(--layout-soybean) var(--layout-stamp);
  width: 100%;
`;

export const levelOneContentStyle = css`
  display: flex;
  gap: var(--layout-stamp);
  align-items: center;
  color: var(--base-text-primary);
`;

export const LevelOneText = styled.div`
  font: var(--heading-sm);
  flex: 1 1 0;
  text-align: left;
  color: inherit;
  display: flex;
`;

export const StyledIconContainer = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
`;

export const menuItemHoverStyle = css`
  &:hover {
    background-color: var(--control-bg-decorative-hover);
  }
`;

export const LabelContainer = styled.div`
  display: flex;
`;

export const StyledStatus = styled(TextStatus)`
  margin-left: var(--layout-seed);
`;
